import { render, staticRenderFns } from "./Approvisionnement.vue?vue&type=template&id=ad479356&"
import script from "./Approvisionnement.vue?vue&type=script&lang=ts&"
export * from "./Approvisionnement.vue?vue&type=script&lang=ts&"
import style0 from "./Approvisionnement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports